import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { ChangePasswordModal } from "./ChangePasswordModal";

export const ChangePasswordButton = observer(() => {
  const { actionModals } = useStores();

  const changePasswordHandler = () => {
    actionModals.open(() => <ChangePasswordModal />, {
      width: "600px",
      title: "Изменение пароля",
      onClose: () => actionModals.closeAll(),
      isOverlayClose: false,
    });
  };

  return (
    <CustomButton type="default" onClick={changePasswordHandler}>
      Изменить пароль
    </CustomButton>
  );
});
